import { render, staticRenderFns } from "./SectionToc.vue?vue&type=template&id=a5d70524&scoped=true"
import script from "./SectionToc.vue?vue&type=script&lang=js"
export * from "./SectionToc.vue?vue&type=script&lang=js"
import style0 from "./SectionToc.vue?vue&type=style&index=0&id=a5d70524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d70524",
  null
  
)

export default component.exports